import { render } from "./TourOperators.vue?vue&type=template&id=965a6cdc&scoped=true"
import script from "./TourOperators.vue?vue&type=script&lang=js"
export * from "./TourOperators.vue?vue&type=script&lang=js"

import "./TourOperators.vue?vue&type=style&index=0&id=965a6cdc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-965a6cdc"]])

export default __exports__